import React from "react";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/collapse";
import { NavLink, useNavigate } from "react-router-dom";
import { auth } from "../firebase";

const Nav = ({ Toggle, MobileToggle, isLoggedIn, setIsLoggedIn }) => {
  const navigate = useNavigate();
  const currentUser = auth.currentUser;
  const accountName = currentUser?.displayName || currentUser?.email || "Signed-in user";
  const accountDetail = currentUser?.displayName && currentUser?.email
    ? currentUser.email
    : "Account";

  const removeToken = async () => {
    await auth.signOut();
    localStorage.removeItem("@token");
    setIsLoggedIn(false);
    navigate("/");
  };

  return (
    <nav className="topbar navbar navbar-expand-sm navbar-white bg-white">
      <button className="sidebar-toggle navbar-brand" type="button" onClick={Toggle} aria-label="Toggle navigation"><i className="bi bi-layout-sidebar-inset" /></button>
      <button
        className="navbar-toggler d-lg-none"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapsibleNavId"
        aria-controls="collapsibleNavId"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <i className="bi bi-person-circle" onClick={MobileToggle}></i>
      </button>
      <div className="collapse navbar-collapse" id="collapsibleNavId">
        <ul className="navbar-nav ms-auto mt-2 mt-lg-0">
          {isLoggedIn ? (
            <li className="nav-item dropdown">
              <button
                className="account-trigger dropdown-toggle"
                id="dropdownId"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              ><span className="account-avatar"><i className="bi bi-person" /></span><span className="account-copy"><strong>{accountName}</strong><small>{accountDetail}</small></span></button>
              <div className="dropdown-menu" aria-labelledby="dropdownId">
                <NavLink
                  to="/profile"
                  style={{ textDecoration: "none", color: "inherit" }}
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}>
                  <button className="dropdown-item">Profile</button>
                </NavLink>

                <button className="dropdown-item" onClick={removeToken}>
                  Log out
                </button>
              </div>
            </li>
          ) : (
            <li className="nav-item">
              <NavLink to="/" className="nav-link">
                Login
              </NavLink>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
